import { render, staticRenderFns } from "./RetouchersInfoBlock.vue?vue&type=template&id=04839afa&"
import script from "./RetouchersInfoBlock.vue?vue&type=script&lang=js&"
export * from "./RetouchersInfoBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports